import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from "@angular/core";
// import { MAX_AMOUNT } from '@root/config';
import { HouseStatusService } from "@root/router/deprecated_and_do_not_use-house/house-status/house-status.service";
import _ from "lodash";
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl } from "@angular/forms";
import * as moment from "moment";
import { Moment } from "moment";
import { AuthorityService } from "@root/shared/business-sevice/authority.service";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";

import { SearchDateAndHouseComponent } from "@root/component/search-components/search-date-and-house/search-date-and-house.component";
import { WritePermissionGurd, BeFalseAfter } from "@root/util/decorator";
import { TranslateService } from "@root/shared/service/translate.service";
import { InternationalService } from "@root/international.service";
import { OperateSidebarService } from "../operate-sidebar.service";
import { ModalService } from "@root/router/index/modal.service";
import { getBytesLength } from "@root/util/util";
import { StoreService } from "@root/shared/service/store.service";
import { HouseStatusSettingService } from "@root/router/setting/custom-config/house-status-setting.service";
import { CurrencyService } from "@root/component/currency-dropdown/currency.service";
import { forkJoin } from "rxjs";
import { AppService } from "@root/app.service";
import { Child, MultiHouseCalendarService } from "../../calendar/multi-house-calendar/multi-house-calendar.service";
import { DateService } from "@root/shared/service/date.service";
import { CacheService } from "@delon/cache";
import { NzSelectComponent } from "ng-zorro-antd/select";

interface HouseItem {
  house_id: number;
  title: string;
  check_in: Moment;
  check_out: Moment;
  price: number;
  input_text?: string;
}

@Component({
  selector: "host-manual-order",
  templateUrl: "./manual-order.component.html",
  styleUrls: ["./manual-order.component.scss"],
})
export class ManualOrderComponent implements OnInit {
  private readonly commissionRatesKey = "hostex_manual_order_commission_rates";
  @ViewChild("paidAmount")
  paidAmount: ElementRef;
  @Input() house: Child;
  @Input() dateRange: Array<string | Date>;
  listOfChannels = [];
  listOfIncomeMethod = [];
  listOfCurrency = [];
  listOfHouse: Array<HouseItem> = [];
  // @Input() houseCleanStatus = null;
  /** 手工订单的日期与其他日期不同，需要特殊处理 */
  // _dateRange: Array<string> = [];
  @Output() success = new EventEmitter();
  @BeFalseAfter(2000) btnLoading = false;
  noteStatus: "none" | "editing" = "none";
  checking = false;
  hasDuplicateGuest = false;
  isExistedGuest = false;

  exchangeRate = 1; // 汇率 外币/人民币
  commissionRate;
  listOfCommissionRate = this.getCommissionRatesFromLocal() || [10, 12, 15];

  listOfCountryCode = [];

  countryCode;

  // maxAmount = MAX_AMOUNT;
  form: UntypedFormGroup = this.fb.group({
    client_id: null,
    name: ["", Validators.required],
    mobile: [""],
    email: null,
    // number_of_guests: 1,
    channel: [null, Validators.required],
    guests: {
      adults: 1,
      children: 0,
      infants: 0,
      pets: 0,
    },
    // price: [null, Validators.required],
    currency_type: this.international.getCurrency(),
    commission: null,
    note: "",
    paid_amount: "",
    payment_method: null,
  });

  isInternational = this.app.app.international;
  displayCommissionRateMenu = false;
  get limitMax() {
    return Math.floor(999999999 / this.exchangeRate);
  }

  get totalHouseFee() {
    const houses = _.filter(this.listOfHouse, (h) => !_.isNil(h.price));
    return houses.length ? _.sumBy(houses, (h) => h.price || 0) : "-";
  }

  get totalNetHouseFee() {
    if (this.totalHouseFee === "-") {
      return "-";
    }

    const commission = this.form.get("commission").value || 0;
    return this.totalHouseFee - commission;
  }

  private compositionFlag = false;
  constructor(
    private fb: UntypedFormBuilder,
    private httpService: HouseStatusService,
    private houseCalendarService: MultiHouseCalendarService,
    private authorityService: AuthorityService,
    private modalService: NzModalService,
    private messageService: NzMessageService,
    private translate: TranslateService,
    private international: InternationalService,
    private operateSidebarService: OperateSidebarService,
    private globalModalService: ModalService,
    private storeService: StoreService,
    private cfgSrv: HouseStatusSettingService,
    private currencySrv: CurrencyService,
    private dateSrv: DateService,
    private cache: CacheService,
    private app: AppService,
  ) {}

  ngOnInit() {
    if (this.house) {
      const house = {
        house_id: this.house.c_id,
        title: this.house.c_title,
        check_in: moment(_.head(this.dateRange)),
        check_out: moment(_.last(this.dateRange)).add(1, "d"),
        price: null,
      };

      this.listOfHouse = this.updateHouseInputText([house]);
    }
    this.initOptions();
    // this.form.get('price').valueChanges.subscribe(res => {
    //   console.log('change: ', res);
    // });

    if (this.isInternational) {
      this.fetchCountryCodes();
    }
  }

  private fetchCountryCodes() {
    this.cache.get("/api/schedule/staff/mobile_codes").subscribe((rst: any) => {
      this.listOfCountryCode = rst?.data?.codes?.map((c) => ({
        label: c,
        value: c,
      }));
      this.countryCode = this.listOfCountryCode?.[0]?.value;
    });
  }

  private initOptions() {
    forkJoin([this.currencySrv.fetchCurrencyList(), this.cfgSrv.getSettings()]).subscribe((rst: any[]) => {
      const currency = rst[0]?.data?.currency_list;
      const cfg = rst[1]?.data;

      this.listOfCurrency = currency?.map((c) => ({ label: c, value: c }));

      this.listOfChannels = cfg?.reservation_channel
        ?.filter((c) => !c.delete_time)
        .map((c) => ({ label: c.channel_name, value: c.code }));

      this.listOfIncomeMethod = cfg?.income_method
        ?.filter((c) => !c.delete_time)
        .map((c) => ({ label: c.method_name, value: c.code }));
    });
  }

  removeHouseItem(house) {
    _.remove(this.listOfHouse, { house_id: house.house_id });
  }

  fetchExchangeRate(from, to) {
    this.httpService.getExchangeRate({ from, to }).subscribe((res) => {
      console.log("exchange: ", res);
      this.exchangeRate = _.get(res, "data.quote") || 1;
    });
  }

  changeDate(value) {
    let start = _.head(value);
    let end = _.last(value);
    if (moment(start).isSame(end, "d")) {
      end = moment(end).add(1, "d");
    }

    const head = moment(start);
    const last = moment(end);

    // while (this.hasDisabledBetween(head, last)) {
    //   last.subtract(1, 'd');
    // }

    const id = this.house.c_id;

    this.houseCalendarService.select({
      status: "done",
      dates: { head, last },
      data: { id },
    });
  }

  checkFormValid() {
    this.checking = true;
    // if (_.isNil(this.form.get("paid_amount").value)) {
    //   console.log('checkFormValie:');
    //   return (
    //     this.form.valid && !this.invalid(this.form.get("payment_method").value)
    //   );
    // }
    const paidAmount = +this.form.get("paid_amount").value;
    if (_.isNil(paidAmount) || paidAmount === 0) {
      /** 不填已收房款，则不需要校验交易方式 */
      return this.form.valid;
    } else {
      /** 填写了已收房款，则需要校验交易方式 */
      return this.form.valid && !_.isNil(this.form.get("payment_method").value);
    }
  }

  compositionstart(control) {
    this.compositionFlag = true;
  }
  compositionend(control) {
    this.compositionFlag = false;
    this.checkIfHasDuplicateGuest(control);
  }

  checkIfHasDuplicateGuest(control?) {
    if (this.compositionFlag) {
      return;
    }

    const value = this.form.value;
    const limit = control === "mobile" ? 5 : 3;
    if (value.name || value.mobile || value.email) {
      if (getBytesLength(value[control]) >= limit) {
        this.requestDuplicateGuests();
      }
    } else {
      this.hasDuplicateGuest = false;
    }
  }

  requestDuplicateGuests() {
    const value = this.form.value;
    const params = {
      page: "1",
      page_size: "100",
      format: "reservation_add_client",
      search_arr: `${value.name || ""},${value.mobile || ""},${value.email || ""},`,
    };

    this.operateSidebarService.fetchGuestList(params).subscribe((res) => {
      if (res.data.list && res.data.list.length) {
        this.hasDuplicateGuest = true;
      } else {
        this.hasDuplicateGuest = false;
      }
    });
  }

  requestSaveManualOrder() {
    const forms = { ...this.form.value };
    const status = forms.paid_amount > 0 ? 1 : 0;
    const commission = forms.commission === null ? 0 : forms.commission;
    const reservations = _.map(this.listOfHouse, (house) => ({
      house_id: house.house_id,
      price: house.price,
      check_in: house.check_in.format("YYYY-MM-DD"),
      // check_out: house.check_out.add(1, "d").format("YYYY-MM-DD"),
      check_out: house.check_out.format("YYYY-MM-DD"),
    }));
    const number_of_adults = forms.guests?.adults;
    const number_of_children = forms.guests?.children;
    const number_of_infants = forms.guests?.infants;
    const number_of_pets = forms.guests?.pets;

    const mobile = forms.mobile ? (this.isInternational ? `${this.countryCode} ${forms.mobile}` : forms.mobile) : null;

    delete forms["guests"];

    const params = {
      ...forms,
      mobile,
      status,
      commission,
      reservations,
      number_of_adults,
      number_of_children,
      number_of_infants,
      number_of_pets,
    };
    // if (!params.status) {
    //   delete params.payment_method;
    //   delete params.paid_amount;
    // }

    this.httpService.bookByHand(params).subscribe((res) => {
      if (res && res.error_code === 0) {
        this.refreshCalendar();
        this.success.emit();
      }
    });
  }

  refreshCalendar() {
    this.houseCalendarService.calendarRefreshRaw$.next(null);
  }

  @WritePermissionGurd("calendar")
  onClickSave() {
    if (this.btnLoading) {
      return;
    }

    if (!this.checkFormValid()) {
      return;
    }

    if (_.find(this.listOfHouse, (house) => _.isNil(house.price))) {
      this.modalService.confirm({
        // nzTitle: '您还未输入房费，确定保存吗？',
        nzTitle: this.translate.syncGet("warning.sidebar.empty_fee"),
        nzOnOk: () => this.requestSaveManualOrder(),
      });
    } else {
      this.btnLoading = true;
      this.requestSaveManualOrder();
    }
  }

  onClickCancel() {
    this.success.emit();
  }

  /** trick  */
  onSearchBlur(tpl: NzSelectComponent) {
    this.countryCode = tpl.activatedValue;
  }

  onInputFocus() {
    const value = this.form.get("paid_amount").value;
    if (this.totalHouseFee !== "-" && !value) {
      const commission = this.form.get("commission").value ?? 0;
      this.form.patchValue({ paid_amount: this.totalHouseFee - commission });
      this.paidAmount.nativeElement.select();
    }
    // _.delay(() => {
    //   if (this.paidAmount) {
    //     const total =
    //       this.form.get('price').value - this.form.get('commission').value;
    //     this.form.patchValue({ paid_amount: total });
    //     this.paidAmount.focus();
    //     this.paidAmount.inputElement.nativeElement.select();
    //   }
    // }, 500);
  }

  hasWritePermission() {
    return this.authorityService.hasWritePermission("calendar");
  }

  invalid(value) {
    return _.isUndefined(value) || _.isNull(value) || (!value && value !== 0);
  }

  onCompleteCommissionRate() {
    this.displayCommissionRateMenu = false;

    if (!_.isNil(this.commissionRate) && this.checkCommissionRateValidity()) {
      this.calculateCommission();

      this.updateCommissionRateList();
      this.saveCommissionRatesToLocal();
    }
  }

  onSelectCommissionRate(rate: number) {
    this.commissionRate = rate;
    this.displayCommissionRateMenu = false;
    this.calculateCommission();
  }

  onDeleteCommissionRate(rate: number) {
    console.log("delete commission rate: ", rate);
    _.remove(this.listOfCommissionRate, (r) => r === rate);
    this.saveCommissionRatesToLocal();
    console.log("listOfCommissionRate: ", this.listOfCommissionRate);
  }

  private checkCommissionRateValidity() {
    const decimal = this.commissionRate.toString().split(".")[1];

    if (decimal && decimal.length > 2) {
      this.messageService.warning("佣金率需在0-100之间，最多2位小数");
      return false;
    }
    if (this.commissionRate > 100 || this.commissionRate < 0) {
      this.messageService.warning("佣金率需在0-100之间，最多2位小数");
      return false;
    }

    return true;
  }

  private calculateCommission() {
    // if (this.commissionRate > 100 || this.commissionRate < 0) {
    //   return this.messageService.warning('佣金率需在0-100之间，最多2位小数');
    // }
    if (this.commissionRate && this.totalHouseFee !== "-") {
      const commission = (this.totalHouseFee * this.commissionRate) / 100;
      this.form.patchValue({ commission });
    }
  }

  private updateHouseInputText(houses: HouseItem[]): HouseItem[] {
    return houses.map((item) => ({
      ...item,
      input_text: `${item.title}（${this.dateSrv.format(item.check_in, ["YMD"])} ~ ${this.dateSrv.format(
        item.check_out,
        ["YMD"],
      )}）`,
    }));
  }

  private updateCommissionRateList() {
    if (this.listOfCommissionRate.indexOf(this.commissionRate) === -1) {
      this.listOfCommissionRate.unshift(this.commissionRate);

      if (this.listOfCommissionRate.length > 10) {
        this.listOfCommissionRate.pop();
      }
    }
  }

  private getCommissionRatesFromLocal() {
    return this.storeService.get(this.commissionRatesKey, 2);
  }

  private saveCommissionRatesToLocal() {
    this.storeService.set(this.commissionRatesKey, this.listOfCommissionRate, 2);
    // if (this.listOfCommissionRate.indexOf(this.commissionRate) === -1) {
    //   this.listOfCommissionRate.unshift(this.commissionRate);
    //   this.storeService.set(this.commissionRatesKey, this.listOfCommissionRate, 2)
    // }
  }

  // watchInputNumberChange() {
  //   const price = this.form.value.price;
  //   const commission = this.form.value.commission;
  //   this.form.patchValue({
  //     price: this.toNumber(price),
  //     commission: this.toNumber(commission)
  //   });
  // }

  displayDuplicateGuestModal() {
    const value = this.form.value;
    const modal = this.globalModalService.displayDuplicateGuestModal({
      guestInfo: { name: value.name, phone: value.mobile, email: value.email },
    });
    modal.afterClose.subscribe((res) => {
      console.log("close res: ", res);
      if (!res) {
        return;
      }

      const { type, data } = res;

      if (type === "onClickExistGuest") {
        this.isExistedGuest = true;
      } else {
        this.isExistedGuest = false;
      }
      this.form.patchValue({ client_id: data.id, name: data.name, mobile: data.phone, email: data.email });
    });
  }

  displayPickerModal(house?) {
    const houseIds = _.map(this.listOfHouse, "house_id");
    const params = {
      defaultDate: house
        ? { begin: house.check_in.format("YYYY-MM-DD"), end: house.check_out.format("YYYY-MM-DD") }
        : {
            begin: _.get(_.head(this.listOfHouse), "check_in", moment()).format("YYYY-MM-DD"),
            end: _.get(_.head(this.listOfHouse), "check_out", moment()).format("YYYY-MM-DD"),
          },
      defaultHouses: house ? [house.house_id] : null,
      selectedHouses: house ? _.filter(houseIds, (id) => id !== house.house_id) : houseIds,
    };
    console.log("params: ", params);

    const modal = this.modalService.create({
      // nzTitle: '选择房间和日期',
      nzTitle: this.translate.syncGet("component.sidebar.choose_house_and_date"),
      nzWidth: 900,
      nzContent: SearchDateAndHouseComponent,
      nzFooter: null,
      nzComponentParams: params,
    });
    modal.afterClose.subscribe((result) => {
      console.log("after close: ", result);
      if (!result) {
        return;
      }

      const { date, houses } = result;
      if (house) {
        this.updateHouseList(houses, date, house);
      } else {
        this.appendHousesToHouseList(houses, date);
      }
    });
  }
  private appendHousesToHouseList(houses, date) {
    const houseList = _.map(houses, (house) => ({
      house_id: house.id,
      title: house.title,
      check_in: moment(date.begin),
      check_out: moment(date.end),
      price: null,
    }));
    this.listOfHouse = this.updateHouseInputText(_.concat(this.listOfHouse, houseList));
  }
  private updateHouseList(houses, date, house) {
    const list = _.map(houses, (h) => ({
      house_id: h.id,
      title: h.title,
      check_in: moment(date.begin),
      check_out: moment(date.end),
      price: h.id === house.house_id ? house.price : null,
    }));
    this.listOfHouse = this.updateHouseInputText(list);
  }

  private toNumber(value) {
    if (value === null) {
      value = 0;
    }
    let val = `${value}`;

    const decimalReg = /^(-?\d+)(\.\d*)?$/g;
    const excludeNumberReg = /[A-Za-z_]+/g;
    const multiPointReg = /[.*\..*]+/;

    if (!decimalReg.test(val)) {
      val = value
        .replace(excludeNumberReg, (match) => {
          console.log("exclude match: ", match);
          return "";
        })
        .replace(multiPointReg, (m) => {
          console.log("multi match: ", m);
          return "";
        });
    }

    return val;
  }
}
